import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    show: true
}

export const topMenuSlice = createSlice({
    name: 'topMenu',
    initialState,
    reducers: {
        show:{
            reducer(state) {
                state.show = true;
            }
        },
        hide:{
            reducer(state) {
                state.show = false;
            }
        }
    }
})

export const { show ,hide} = topMenuSlice.actions;

export default topMenuSlice.reducer;